var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from 'react';
import { runInAction, when } from 'mobx';
import { observer } from "mobx-react";
import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";
import { message, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { throttle } from 'lodash';
import PrettyDateBox from "../PrettyDateBox";
import Message from '../MessagesTypes/Message';
import ContactListSelector from "../common/ContactListSelector";
import LoadingScreen from "../../LoadingScreen";
import DeletedMessagesInfo from '../MessagesTypes/DeletedMessagesInfo';
import { MESSAGE_STATUS } from '../../../constants';
import { useStore } from '../../../store/rootStore';
import LazyLoadList, { LoadDirection } from '../../Base/Utils/LazyLoadList';
import { MessagesLoading } from '../../../store/ActiveChatStore';
import PrettyDateBoxStatic from '../PrettyDateBox/PrettyDateBoxStatic';
import MessagesListNote from '../ChatNotes/Components/MessagesListNote';
import ChatNotes from '../../Chat/ChatNotes';
import { Portal } from '../../portals';
import { PortalName } from '../../portals/common';
import i18n from '../../../i18n';
import styles from './MessagesList.module.scss';
const NEAR_BOTTOM_THRESHOLD_PX = 80;
let MessagesList = class MessagesList extends Component {
    constructor(props) {
        super(props);
        // Unfortunatelly just comparing value in mobx store 
        // between previous and new props doesn't work,
        // since store always up to date in prev props
        Object.defineProperty(this, "prevChatId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "prevMessageId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "prevLastMessageId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "messagesEndRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unreadMessageRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "scrollToMessageRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rootRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadWaitDispose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "scrollTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "componentDidMount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a;
                if (this.props.reference) {
                    this.props.reference(this);
                }
                this.scrollToTarget();
                this.updatePreviousScrollMarkers();
                (_a = this.rootRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', this.onScrollListener);
            }
        });
        Object.defineProperty(this, "componentWillUnmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a;
                if (this.loadWaitDispose) {
                    this.loadWaitDispose();
                }
                if (this.props.reference) {
                    this.props.reference(null);
                }
                if (this.scrollTimeout) {
                    clearTimeout(this.scrollTimeout);
                }
                (_a = this.rootRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', this.onScrollListener);
            }
        });
        Object.defineProperty(this, "isNearBottom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const container = this.rootRef.current;
                if (!container) {
                    return this.state.onBottom;
                }
                return container.scrollHeight - container.scrollTop - container.clientHeight <= NEAR_BOTTOM_THRESHOLD_PX;
            }
        });
        Object.defineProperty(this, "updatePreviousScrollMarkers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { messageId, chat, messages } = this.props.store.activeChatStore;
                this.prevChatId = chat ? chat._id : null;
                this.prevMessageId = messageId;
                this.prevLastMessageId = messages.length ? messages[messages.length - 1]._id : null;
            }
        });
        Object.defineProperty(this, "onScrollListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: throttle(() => {
                const { currentDateLabel, isScrolling } = this.state;
                const { messagesLoading } = this.props.store.activeChatStore;
                const container = this.rootRef.current;
                if (!container)
                    return;
                if (messagesLoading === MessagesLoading.ALL)
                    return;
                // @ts-ignore Should be 'null' instead of any
                let newLabel = null;
                if (!isScrolling) {
                    this.setState({ isScrolling: true });
                }
                const dateLabels = container.querySelectorAll(".date-label");
                dateLabels.forEach((dateLabel) => {
                    if (container.scrollTop >= dateLabel.offsetTop) {
                        newLabel = dateLabel;
                    }
                });
                if (newLabel && newLabel.innerText !== currentDateLabel) {
                    this.setState({ currentDateLabel: newLabel.innerText });
                }
                if (this.scrollTimeout) {
                    clearTimeout(this.scrollTimeout);
                }
                this.scrollTimeout = setTimeout(() => {
                    this.setState({ isScrolling: false });
                }, 2000);
            }, 100)
        });
        Object.defineProperty(this, "scrollToTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.props.store.activeChatStore.messageId) {
                    this.scrollToMessageId();
                }
                else {
                    this.scrollToBottom();
                }
            }
        });
        /**
         * @todo
         *   Make it work with new pagination system.
         *   For now it disabled because have unpredictable results,
         *   because some of unread messages can be not loaded
         */
        Object.defineProperty(this, "scrollToUnread", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.scrollToBottom();
                // this.whenLoadEnd(() => {
                //     if(this.unreadMessageRef.current){
                //         this.unreadMessageRef.current.scrollIntoView();
                //     } else {
                //         // Seems unread messages in some unloaded part
                //         // so scroll to bottom instead
                //         this.scrollToBottom();
                //     }
                // });
            }
        });
        Object.defineProperty(this, "scrollToBottom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.whenLoadEnd(() => {
                    setTimeout(() => {
                        const { activeChatStore } = this.props.store;
                        // Has next messages so need to load before scroll
                        if (activeChatStore.hasNextMessages) {
                            activeChatStore
                                .loadMessages(true)
                                .then(() => {
                                var _a;
                                (_a = this.messagesEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                            });
                        }
                        else if (this.messagesEndRef.current) {
                            this.messagesEndRef.current.scrollIntoView();
                        }
                        // Pure magic, but otherwise do not work
                    }, 0);
                });
            }
        });
        /** Most likely this not need anymore, because messages already loaded from target ID */
        Object.defineProperty(this, "scrollToMessageId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.whenLoadEnd(() => {
                    setTimeout(() => {
                        if (this.scrollToMessageRef.current) {
                            this.scrollToMessageRef.current.scrollIntoView(false); // Align to bottom
                        }
                    }, 0);
                });
            }
        });
        /** Wait messages loading end */
        Object.defineProperty(this, "whenLoadEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (cb) => {
                this.loadWaitDispose = when(() => this.props.store.activeChatStore.messagesLoading === MessagesLoading.NONE, () => {
                    this.loadWaitDispose = null;
                    cb();
                });
            }
        });
        Object.defineProperty(this, "handleChangeUnreadToRead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isVisible, message) => {
                if (isVisible) {
                    this.props.store.activeChatStore.setMessagesRead([message]);
                }
            }
        });
        Object.defineProperty(this, "checkFirstUnreadMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (messages, key) => {
                if (messages[key].status !== MESSAGE_STATUS.MESSAGE_SEEN && key > 0 && messages[key - 1].status === MESSAGE_STATUS.MESSAGE_SEEN) {
                    return true;
                }
            }
        });
        Object.defineProperty(this, "checkIfOnBottom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isVisible) => {
                if (isVisible) {
                    this.setOnBottom(true);
                    this.props.store.activeChatStore.setMessagesRead(true);
                }
                else {
                    this.setOnBottom(false);
                }
            }
        });
        Object.defineProperty(this, "setOnBottom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (onBottom) => {
                this.setState({ onBottom }, () => {
                    if (typeof this.props.onBottomStateChange === 'function') {
                        this.props.onBottomStateChange(onBottom);
                    }
                });
            }
        });
        Object.defineProperty(this, "checkTimeDiffWithPrevMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (messages, key) => {
                if (messages[key - 1]) {
                    const prevReceived = messages[key - 1].received;
                    const currReceived = messages[key].received;
                    if (!prevReceived || !currReceived)
                        return false;
                    const previousDate = new Date(prevReceived);
                    const currentDate = new Date(currReceived);
                    if (isNaN(previousDate.getTime()) || isNaN(currentDate.getTime()))
                        return false;
                    let timeDiff = currReceived - prevReceived;
                    let previousDay = previousDate.getDate();
                    let currentDay = currentDate.getDate();
                    if (timeDiff > 1000 * 60 * 60 * 24 || previousDay !== currentDay) {
                        return true;
                    }
                    else
                        return false;
                }
                return false;
            }
        });
        Object.defineProperty(this, "highlightMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (messageId) => {
                this.setState({ highlightedId: `message-${messageId}` });
                setTimeout(() => {
                    this.setState({ highlightedId: null });
                }, 1000);
            }
        });
        Object.defineProperty(this, "highlightElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (elementId) => {
                this.setState({ highlightedId: elementId });
                setTimeout(() => {
                    this.setState({ highlightedId: null });
                }, 1000);
            }
        });
        /**
         * Scroll to message of specified ID, optionally loding it
         *
         * @param id ID of message to scroll into view
         * @param animation Whether to animate the scroll
         */
        Object.defineProperty(this, "scrollToMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, animation = true) => {
                const { activeChatStore } = this.props.store;
                if (!activeChatStore.isMessageLoaded(id)) {
                    // Seems outside of loaded list, so load with message
                    this.props.store.activeChatStore.loadMessages(true, false, id)
                        .then(() => {
                        runInAction(() => {
                            this.props.store.activeChatStore.messageId = id;
                        });
                        /* Needs to go to the end of the event loop */
                        setTimeout(() => {
                            this.scrollToId(`message-${id}`, animation);
                        }, 0);
                    })
                        .catch((error) => {
                        console.error('Error loading message', error);
                    });
                }
                else {
                    this.scrollToId(`message-${id}`, animation);
                }
            }
        });
        Object.defineProperty(this, "scrollToNote", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (noteId, messageId, animation = true) => {
                const { activeChatStore } = this.props.store;
                const doScroll = () => {
                    setTimeout(() => {
                        this.scrollToId(`note-${noteId}`, animation);
                    }, 0);
                };
                if (!activeChatStore.isMessageLoaded(messageId)) {
                    activeChatStore.loadMessages(true, false, messageId)
                        .then(() => {
                        doScroll();
                    })
                        .catch((error) => {
                        console.error('Error loading message for note', error);
                    });
                }
                else {
                    doScroll();
                }
            }
        });
        Object.defineProperty(this, "scrollToId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (elementId, animation) => {
                const anchor = document.getElementById(elementId);
                if (anchor) {
                    if (animation) {
                        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                    else {
                        anchor.scrollIntoView(true);
                    }
                    setTimeout(() => {
                        this.highlightElement(elementId);
                    }, 500);
                    return true;
                }
                else {
                    console.error(`Message element not found: #${elementId}`);
                    return false;
                }
            }
        });
        Object.defineProperty(this, "handleForwardMessageOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ forwardMenuOpen: !this.state.forwardMenuOpen });
            }
        });
        Object.defineProperty(this, "addToSelectedMessagesList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (messageId, multichoice) => {
                const temporarySelectedMessages = this.state.temporarySelectedMessages;
                if (temporarySelectedMessages.includes(messageId) && multichoice) {
                    const newList = temporarySelectedMessages.filter((item) => item !== messageId);
                    this.setState({ temporarySelectedMessages: newList });
                }
                else if (multichoice) {
                    this.setState({ temporarySelectedMessages: [...this.state.temporarySelectedMessages, messageId] });
                }
                else if (!multichoice) {
                    this.setState({ temporarySelectedMessages: [messageId] });
                }
                this.handleForwardMessageOpen();
            }
        });
        Object.defineProperty(this, "handleMessageReaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (messageId, reaction) => __awaiter(this, void 0, void 0, function* () {
                const { activeChatStore } = this.props.store;
                try {
                    this.setState({ reactionMessageLoadingId: messageId });
                    if (reaction) {
                        yield activeChatStore.sendReactionMessage(messageId, reaction);
                    }
                    else {
                        yield activeChatStore.removeReactionMessage(messageId);
                    }
                }
                catch (error) {
                    console.error(`Error ${reaction ? 'sending' : 'removing'} message reaction`, error);
                }
                finally {
                    this.setState({ reactionMessageLoadingId: null });
                }
            })
        });
        Object.defineProperty(this, "forwardMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (contactsList) => __awaiter(this, void 0, void 0, function* () {
                const { activeChatStore } = this.props.store;
                const { messages } = activeChatStore;
                const selectedMessages = this.state.temporarySelectedMessages;
                const filteredMessages = messages.filter((message) => {
                    return selectedMessages.includes(message._id);
                });
                return activeChatStore.forwardMessages(contactsList, filteredMessages)
                    .then(() => {
                    this.setState({ temporarySelectedMessages: [] });
                })
                    .catch((error) => {
                    console.error('Error forwarding messages', error);
                    message.error(i18n.t('forwardMessagesError'));
                });
            })
        });
        Object.defineProperty(this, "renderMessagesAndNotes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { chat, messages, messageId: currentOpenMessageId, renderMessagesAsHTML } = this.props.store.activeChatStore;
                const { highlightedId, reactionMessageLoadingId } = this.state;
                const { notesList } = this.props.store.chatNotesStore;
                const elementsToRender = [];
                messages.forEach((message, i) => {
                    var _a;
                    const prevMessage = messages[i - 1];
                    const currentMessage = message;
                    // Add message related elements (date boxes, message itself)
                    if (this.checkTimeDiffWithPrevMessage(messages, i)) {
                        elementsToRender.push(React.createElement(PrettyDateBox, { key: `date-${message._id}-prev`, messages: messages, index: i }));
                    }
                    if (i === 0) { // Always show date box for the very first message
                        elementsToRender.push(React.createElement(PrettyDateBox, { key: `date-${message._id}-first`, messages: messages, index: i }));
                    }
                    elementsToRender.push(React.createElement("div", { key: message._id, id: `message-${message._id}` },
                        React.createElement(VisibilitySensor, { onChange: (isVisible) => this.handleChangeUnreadToRead(isVisible, message) },
                            React.createElement(Message, { message: currentMessage, activeChat: chat, previousMessage: prevMessage, name: (_a = chat === null || chat === void 0 ? void 0 : chat.title) !== null && _a !== void 0 ? _a : '', scrollToMessage: this.scrollToMessage, handleForwardMessage: () => this.addToSelectedMessagesList(message._id, false), isHighlighted: highlightedId === `message-${message._id}`, isReactionLoading: reactionMessageLoadingId === message._id, onSendMessageReaction: (reaction) => this.handleMessageReaction(message._id, reaction), onRemoveMessageReaction: () => this.handleMessageReaction(message._id), renderMessageAsHTML: renderMessagesAsHTML })),
                        currentOpenMessageId && currentOpenMessageId === message._id ? React.createElement("div", { ref: this.scrollToMessageRef }) : null,
                        this.checkFirstUnreadMessage(messages, i) ? React.createElement("div", { ref: this.unreadMessageRef }) : null));
                    // Find and add notes that should appear after this message
                    const notesForThisMessage = notesList.filter(note => note.messageId === message._id);
                    notesForThisMessage.forEach(note => {
                        elementsToRender.push(React.createElement("div", { id: `note-${note._id}`, key: `note-wrapper-${note._id}` },
                            React.createElement(MessagesListNote, { key: `note-${note._id}`, note: note, isHighlighted: highlightedId === `note-${note._id}` })));
                    });
                });
                return elementsToRender;
            }
        });
        Object.defineProperty(this, "renderMessagesLoader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (dir) => {
                const wrapStyle = {};
                if (dir === LoadDirection.PREV) {
                    wrapStyle.top = '20px';
                }
                else {
                    wrapStyle.bottom = '50px';
                }
                return (React.createElement("div", { className: styles.loaderWrap, style: wrapStyle },
                    React.createElement(Spin, { className: styles.loader, indicator: React.createElement(LoadingOutlined, { style: { fontSize: 28, color: 'gray' }, spin: true }) })));
            }
        });
        Object.defineProperty(this, "renderForwardMessagesModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { forwardMenuOpen } = this.state;
                return (React.createElement(ContactListSelector, { visible: forwardMenuOpen, setVisible: (visible) => this.setState({ forwardMenuOpen: visible }), onForwardMessages: this.forwardMessages, multichoice: false, onlyActiveChats: true }));
            }
        });
        this.state = {
            onBottom: false,
            chatLength: 0,
            isScrolling: false,
            currentDateLabel: '',
            highlightedId: null,
            reactionMessageLoadingId: null,
            forwardMenuOpen: false,
            temporarySelectedMessages: [],
        };
        this.messagesEndRef = React.createRef();
        this.unreadMessageRef = React.createRef();
        this.scrollToMessageRef = React.createRef();
        this.rootRef = React.createRef();
    }
    getSnapshotBeforeUpdate(prevProps, prevState) {
        return {
            wasNearBottom: this.isNearBottom(),
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { messageId, chat, messages, hasNextMessages } = this.props.store.activeChatStore;
        const lastMessageId = messages.length ? messages[messages.length - 1]._id : null;
        const isAnotherChat = (chat === null || chat === void 0 ? void 0 : chat._id) !== this.prevChatId;
        const isAnotherTargetMessage = !!messageId && messageId !== this.prevMessageId;
        const hasNewLastMessage = !hasNextMessages && !!lastMessageId && lastMessageId !== this.prevLastMessageId;
        const shouldFollowNewLastMessage = hasNewLastMessage && ((snapshot === null || snapshot === void 0 ? void 0 : snapshot.wasNearBottom)
            || !this.prevLastMessageId);
        if (isAnotherChat || isAnotherTargetMessage) {
            this.scrollToTarget();
        }
        else if (shouldFollowNewLastMessage) {
            this.scrollToBottom();
        }
        this.updatePreviousScrollMarkers();
    }
    render() {
        const { messagesLoading, hasNextMessages, hasPrevMessages, loadMoreMessages, messages, chat } = this.props.store.activeChatStore;
        const { currentDateLabel, isScrolling } = this.state;
        const deletedCount = chat === null || chat === void 0 ? void 0 : chat.msgDeletedCount;
        return (React.createElement(LazyLoadList, { className: styles.messageList, hasPrev: hasPrevMessages, hasNext: hasNextMessages, onLoadPrev: () => loadMoreMessages(MessagesLoading.PREV), onLoadNext: () => loadMoreMessages(MessagesLoading.NEXT), loadingPrev: MessagesLoading.PREV === messagesLoading, loadingNext: MessagesLoading.NEXT === messagesLoading, canLoad: MessagesLoading.ALL !== messagesLoading, renderLoader: (dir) => this.renderMessagesLoader(dir), containerRef: this.rootRef, restoreScrollOnPrependOnly: true },
            React.createElement(Portal, { name: PortalName.chatNotes, waitHost: true },
                React.createElement(ChatNotes, { scrollToNote: this.scrollToNote })),
            MessagesLoading.ALL === messagesLoading &&
                React.createElement(LoadingScreen, null),
            messages.length > 0 && currentDateLabel && (React.createElement(PrettyDateBoxStatic, { text: currentDateLabel, visible: isScrolling })),
            deletedCount && deletedCount > 0 && (React.createElement(DeletedMessagesInfo, { count: deletedCount, chatCreatedDate: chat.created })),
            this.renderMessagesAndNotes(),
            this.renderForwardMessagesModal(),
            React.createElement(VisibilitySensor, { onChange: (isVisible) => this.checkIfOnBottom(isVisible) },
                React.createElement("div", { className: styles.bottomBlock, ref: this.messagesEndRef }))));
    }
};
MessagesList = __decorate([
    observer
], MessagesList);
export default (props) => {
    const store = useStore();
    const { t } = useTranslation();
    return React.createElement(MessagesList, Object.assign({}, props, { store, t }));
};
